import { fetchApiDataV2} from "../../utils/utils"

export const  getShowsByCategory=async (appInfo)=>{
  
    const api=`home`
    return await fetchApiDataV2(appInfo,api)
}

